export default function FavePage() {
  return <div>صفحه علاقه مندی ها</div>;
}
